class Jobs {
	constructor(node) {
		this.JOB_BOARD_NAME = "infinitus";
		this.JOB_BOARD_URL = `https://api.ashbyhq.com/posting-api/job-board/${this.JOB_BOARD_NAME}`;

		this.allJobs = [];
		this.state = {
			selectedDepartment: "",
			selectedLocation: "",
		};

		this.node = node;
		this.cacheElements();

		this.allJobs = this.readRenderedJobs();
		this.fetchJobs();
		this.bindEvents();
	}

	cacheElements() {
		this.jobsContainer = this.node.querySelector("#jobs-container");
		this.jobsWrap = this.node.querySelector("#jobs-wrapper");
		this.showTrigger = this.node.querySelector("#show-roles");
		this.hideTrigger = this.node.querySelector("#hide-roles");
		this.noResults = this.node.querySelector("#jobs-no-results");
		this.selectDepartment = this.node.querySelector(".lever-jobs-filter-team");
		this.selectWorkLocation = this.node.querySelector(".lever-jobs-filter-location");
	}

	// Rows server-rendered by blocks/jobs/jobs.php, so filtering works even if the refresh fails.
	readRenderedJobs() {
		return Array.from(this.jobsContainer.querySelectorAll(".job"), (row) => {
			const link = row.querySelector(".job-title");
			return {
				title: link.textContent,
				jobUrl: link.getAttribute("href"),
				department: row.dataset.department,
				location: row.dataset.location,
			};
		});
	}

	bindEvents() {
		this.showTrigger.addEventListener("click", () => this.toggleJobsVisibility(true));
		this.hideTrigger.addEventListener("click", () => this.toggleJobsVisibility(false));

		this.selectDepartment.addEventListener("change", (e) => {
			this.handleFilter({ selectedDepartment: e.target.value });
		});

		this.selectWorkLocation.addEventListener("change", (e) => {
			this.handleFilter({ selectedLocation: e.target.value });
		});
	}

	toggleJobsVisibility(show) {
		this.showTrigger.classList.toggle("hide", show);
		this.hideTrigger.classList.toggle("hide", !show);
		this.jobsWrap.classList.toggle("active", show);
	}

	render(jobs) {
		if (!Array.isArray(jobs)) {
			console.error('Invalid jobs data provided to render method');
			return;
		}

		const jobsHtml = jobs.map(job => `
			<div class="job" data-department="${this.escapeHtml(job.department)}" data-location="${this.escapeHtml(job.location)}">
				<a class="text-white display-xs job-title" href="${job.jobUrl}">${this.escapeHtml(job.title)}</a>
				<a class="job-cta btn btn-sm text-white" href="${job.jobUrl}" target="_blank" rel="noopener noreferrer">Learn more</a>
			</div>
		`).join('');

		this.jobsContainer.innerHTML = jobsHtml;
		this.toggleNoResultsMessage(jobs.length === 0);
	}

	escapeHtml(str) {
		if (!str || typeof str !== 'string') return '';
		return str
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	}

	async fetchJobs() {
		try {
			const response = await fetch(this.JOB_BOARD_URL);

			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const data = await response.json();

			if (!data || !Array.isArray(data.jobs)) {
				throw new Error('Invalid data format received from API');
			}

			this.allJobs = data.jobs;
			this.render(this.allJobs);
			this.populateFilterOptions();
		} catch (error) {
			console.error("Error fetching jobs data:", error);
			this.toggleNoResultsMessage(!this.allJobs.length);
		}
	}

	toggleNoResultsMessage(show) {
		this.noResults.style.display = show ? "block" : "none";
	}

	populateFilterOptions() {
		this.populateDepartmentOptions();
		this.populateLocationOptions();
	}

	populateDepartmentOptions() {
		try {
			const departments = this.getUniqueValues('department');
			const options = this.createFilterOptions(departments, 'Team');
			this.selectDepartment.innerHTML = options;
		} catch (error) {
			console.error("Error populating department options:", error);
		}
	}

	populateLocationOptions() {
		try {
			const locations = this.getUniqueValues('location');
			const options = this.createFilterOptions(locations, 'Location');
			this.selectWorkLocation.innerHTML = options;
		} catch (error) {
			console.error("Error populating location options:", error);
		}
	}

	getUniqueValues(property) {
		return new Set(this.allJobs.map(job => job[property]).filter(Boolean));
	}

	createFilterOptions(uniqueValues, defaultLabel) {
		let options = `<option value="all">${defaultLabel}</option>`;

		[...uniqueValues].sort().forEach(value => {
			options += `<option value="${this.escapeHtml(value)}">${this.escapeHtml(value)}</option>`;
		});

		return options;
	}

	handleFilter(selectedItems = {}) {
		const { selectedDepartment, selectedLocation } = selectedItems;

		if (selectedDepartment !== undefined) {
			this.state.selectedDepartment = selectedDepartment === "all" ? "" : selectedDepartment;
		}

		if (selectedLocation !== undefined) {
			this.state.selectedLocation = selectedLocation === "all" ? "" : selectedLocation;
		}

		const filteredJobs = this.filterJobs();

		this.render(filteredJobs);
	}

	filterJobs() {
		const { selectedDepartment, selectedLocation } = this.state;

		return this.allJobs.filter(job => {
			const matchesDepartment = !selectedDepartment || job.department === selectedDepartment;
			const matchesLocation = !selectedLocation || job.location === selectedLocation;
			return matchesDepartment && matchesLocation;
		});
	}
}

// Standalone bundle, enqueued by acf/jobs and excluded from WP Rocket Delay JS
// (functions/scripts.php) so the list refreshes and filters work on load.
const init = () => document.querySelectorAll(".block-jobs").forEach(node => new Jobs(node));

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
